const fields = [
  ['orderNo', 'Pedido'], ['lineNo', 'Linea'], ['customerCode', 'Codigo cliente'], ['customerName', 'Cliente'],
  ['destinationCode', 'Codigo destino'], ['destinationName', 'Destino'],
  ['itemCode', 'Codigo producto'], ['itemName', 'Producto'], ['varietyCode', 'Codigo variedad'], ['varietyName', 'Variedad'],
  ['confectionCode', 'Codigo confeccion'], ['confectionName', 'Confeccion'],
  ['brand', 'Marca'], ['warehouseCode', 'Codigo almacen'], ['warehouseName', 'Almacen'],
  ['plannedDepartureDate', 'Fecha de salida'], ['controlMoment', 'Momento del control'], ['result', 'Resultado'],
  ['responsibleUserId', 'Responsable'], ['notes', 'Observaciones'],
  ['detail.certifiedProduct', 'Producto certificado'], ['detail.palletType', 'Tipo de palet'],
  ['detail.packages', 'Bultos'], ['detail.boxType', 'Tipo de caja'], ['detail.caliber', 'Calibre'],
  ['detail.realCaliber', 'Calibre real'], ['detail.band', 'Banda'], ['detail.realVariety', 'Variedad real'],
  ['detail.minWeight', 'Peso minimo'], ['detail.packagingStatus', 'Estado del envase'],
  ['detail.orderedPallets', 'Palets del pedido'], ['detail.totalExtension', 'Total ampliacion'],
  ['detail.lineNotes', 'Observaciones de linea'], ['detail.qualityNotes', 'Observaciones de calidad'],
]
const read = (data, path) => path.split('.').reduce((value, key) => value?.[key], data)
const text = value => value == null || value === '' ? '-' : String(value)

export const qualityEventLabel = event => ({
  CONTROL_CREATED: 'Control creado', CONTROL_UPDATED: 'Control modificado',
  COMPLETED_CONTROL_CORRECTED: 'Control completado corregido', STATUS_CHANGED: 'Cambio de estado',
}[event.eventType] || event.eventType)

export const qualityControlChanges = (event) => {
  if (!['CONTROL_UPDATED', 'COMPLETED_CONTROL_CORRECTED'].includes(event.eventType)) return []
  const before = event.previousData || {}
  const after = event.newData || {}
  const changes = fields.filter(([path]) => read(after, path) !== undefined && text(read(before, path)) !== text(read(after, path)))
    .map(([path, label]) => ({ label, before: text(read(before, path)), after: text(read(after, path)) }))
  const oldChecks = new Map((before.checks || []).map(item => [JSON.stringify([item.section, item.code]), item]))
  const nextChecks = new Map((after.checks || []).map(item => [JSON.stringify([item.section, item.code]), item]))
  if (after.checks) for (const key of new Set([...oldChecks.keys(), ...nextChecks.keys()])) {
    const old = oldChecks.get(key)
    const check = nextChecks.get(key)
    if (JSON.stringify(old?.value ?? null) !== JSON.stringify(check?.value ?? null) || text(old?.notes) !== text(check?.notes)) {
      changes.push({ label: check?.label || old?.label || check?.code || old?.code, before: [text(old?.value), old?.notes].filter(Boolean).join(' | '), after: [text(check?.value), check?.notes].filter(Boolean).join(' | ') })
    }
  }
  const photoTypes = new Set([...(before.photos || []), ...(after.photos || [])].map(photo => photo.photoType))
  if (after.photos) for (const type of photoTypes) {
    const ids = data => (data.photos || []).filter(photo => photo.photoType === type).map(photo => String(photo.fileId)).sort().join(',')
    if (ids(before) !== ids(after)) changes.push({ label: { MESH_LABEL: 'Foto de malla', BOX_LABEL: 'Foto de caja' }[type] || 'Fotografia', before: ids(before) ? 'Adjunta' : '-', after: ids(after) ? (ids(before) ? 'Sustituida' : 'Adjunta') : 'Retirada' })
  }
  if (after.signatures) {
    const signature = data => (data.signatures || []).find(item => item.signatureType === 'RESPONSIBLE')
    const old = signature(before)
    const next = signature(after)
    if (JSON.stringify([old?.signatureData ?? null, old?.fileId ?? null]) !== JSON.stringify([next?.signatureData ?? null, next?.fileId ?? null])) {
      changes.push({ label: 'Firma del responsable', before: old ? 'Registrada' : '-', after: next ? (old ? 'Actualizada' : 'Registrada') : 'Retirada' })
    }
  }
  return changes
}
